import { MaskPrice } from "../../utils";

export interface InputCurrencyProps {
  label: string,
  id: string,
  name?: string,
  className?: string,
  disabled: boolean,
  value: string,
  allowNegative?: boolean;
  OnChange(price: string);
}

export default function InputCurrency(props: InputCurrencyProps) {

  function OnPriceChange(element: React.ChangeEvent<HTMLInputElement>) {
    const oldCaretPosition = element.target.selectionStart;
    const price = element.target.value;
    const priceMasked = MaskPrice(price, props.allowNegative)
    props.OnChange(priceMasked);
    element.target.setSelectionRange(oldCaretPosition ?? 0, oldCaretPosition ?? 0);
  }

  return (
    <>
      <label htmlFor={props.id}>{props.label}</label>
      <input
        id={props.id}
        name={props.name}
        className={props.className}
        autoComplete="product-name"
        disabled={props.disabled}
        value={props.value}
        onChange={e => OnPriceChange(e)}
      />
    </>
  );
}
